// extracted by mini-css-extract-plugin
module.exports = {"root":"Category_root__3Gl8t","label":"Category_label__11fqY","content":"Category_content__3Np3M","header":"Category_header__2p5lt","location":"Category_location__64SsV"};